"use strict";

exports.__esModule = true;
exports.VisualMapSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
var _Form = require("../../Form");
var _styledComponents = require("styled-components");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var VisualMapSelector = exports.VisualMapSelector = function VisualMapSelector(props) {
  var _visualMap$props, _visualMap$props2;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var elementEditor = props.elementEditor,
    path = props.path,
    visualMap = props.visualMap;
  var defaultColor = theme.DefaultChartColor || "#1678c2";
  (0, _react.useEffect)(function () {
    if (!visualMap || Object.entries(visualMap).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.visualMap",
          value: el.props.visualMap = {
            show: false,
            defaultColor: defaultColor,
            props: []
          }
        };
      });
    }
  }, [visualMap, elementEditor, path]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "VisualMapSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("VisualMapSelector.visualMapOptions.label", "Visual map options")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("VisualMapSelector.visualMapShow.switch", "Show visual map"),
    "data-testid": "VisualMapSelector.visualMapShow.switch",
    checked: visualMap == null ? void 0 : visualMap.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.visualMap.show",
          value: el.props.visualMap.show = e.target.checked
        };
      });
    }
  }), (visualMap == null || (_visualMap$props = visualMap.props) == null ? void 0 : _visualMap$props.length) > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("VisualMapSelector.visualMapDefaultColor.label", "Default color")
  }, /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, {
    "data-testid": "VisualMapSelector.visualMapDefaultColor.picker",
    style: {
      width: "45px"
    },
    value: (visualMap == null ? void 0 : visualMap.defaultColor) || defaultColor,
    onChange: function onChange(color) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.visualMap.defaultColor",
          value: el.props.visualMap.defaultColor = color
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("VisualMapSelector.visualMapColors.label", "Map colors"),
    style: {
      marginBottom: "3px"
    }
  })), visualMap == null || (_visualMap$props2 = visualMap.props) == null ? void 0 : _visualMap$props2.map(function (map, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "5px"
      },
      key: "VisualMapSelector-" + index
    }, /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, {
      "data-testid": "VisualMapSelector.visualMapColor.picker",
      style: {
        width: "45px"
      },
      value: map.color,
      onChange: function onChange(color) {
        return elementEditor.modifyElementAt(path, function (el) {
          return {
            item: "el.props.visualMap.props[" + index + "].color",
            value: el.props.visualMap.props[index].color = color
          };
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      content: translate("VisualMapSelector.visualMapGraterThan.tooltip", "Greater Than"),
      position: _core.Position.LEFT
    }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
      "data-testid": "VisualMapSelector.visualMapGraterThan.input",
      style: {
        width: "45px"
      },
      value: map.gt,
      onValueChange: function onValueChange(value) {
        if (value < map.lte) {
          elementEditor.modifyElementAt(path, function (el) {
            return {
              item: "el.props.visualMap.props[" + index + "].gt",
              value: el.props.visualMap.props[index].gt = value
            };
          });
        }
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      content: translate("VisualMapSelector.visualMapLessThanOrEqual.tooltip", "Less Than or Equal"),
      position: _core.Position.LEFT
    }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
      "data-testid": "VisualMapSelector.visualMapLessThanOrEqual.input",
      style: {
        width: "55px"
      },
      value: map.lte,
      onValueChange: function onValueChange(value) {
        if (value !== map.gt && value > map.gt) {
          elementEditor.modifyElementAt(path, function (el) {
            return {
              item: "el.props.visualMap.props[" + index + "].lte",
              value: el.props.visualMap.props[index].lte = value
            };
          });
        }
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "VisualMapSelector.visualMapRemove.button",
      icon: _icons.IconNames.REMOVE,
      onClick: function onClick() {
        var tempVisualMaps = JSON.parse(JSON.stringify(visualMap.props));
        tempVisualMaps.splice(index, 1);
        elementEditor.modifyElementAt(path, function (el) {
          return {
            item: "el.props.visualMap.props",
            value: el.props.visualMap.props = tempVisualMaps
          };
        });
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    text: translate("VisualMapSelector.visualMapAdd.button", "Add visual map"),
    "data-testid": "VisualMapSelector.visualMapAdd.button",
    icon: _icons.IconNames.ADD,
    onClick: function onClick() {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.visualMap.props",
          value: el.props.visualMap.props = [].concat(visualMap.props && visualMap.props.length > 0 ? visualMap.props : [], [{
            color: defaultColor,
            gt: 0,
            lte: 1
          }])
        };
      });
    }
  }));
};